<template>
  <div class="page-content">
    <div class="newMine">
      <div class="newMine_top">
        <div class="newMine_info">
          <el-image style="width: 120px; height: 160px; margin-right: 10px;" :src="user.photo||userPhoto" :fit="fit"></el-image>
          <div class="info_student">
            <p class="txtOver">
              <span style="font-size: 16px;font-weight: 650;">{{user.name}}</span>
              <span style="margin-left: 15px;"> {{user.phone}}</span>
            </p>
            <p class="txtOver">
              <i class="el-icon-school"></i>
              所属学校：{{user.schCode}}-{{user.schName}}</p>
            <p class="txtOver">
              <i class="el-icon-collection"></i>
              所属专业：{{user.specialtyName}}</p>
            <p class="txtOver">
              <i class="el-icon-s-order"></i>
              专业层次：{{mapType(user.eduLevel,'eduLevel')}}
              <i v-if="isCanRefresh" @click="handleRefresh" class="el-icon-refresh" style="color:#0065BA; cursor: pointer;"></i>
            </p>
            <p class="txtOver">
              <i class="el-icon-postcard"></i>
              准考证号：{{ user.certiNo }}</p>
          </div>
        </div>
        <div class="newMine_news">
          <div class="news_top">
            <div>新闻公告</div>
            <div class="news_more">
              <router-link class="nav-link" :to="{ path: '/news' }">
                <span>更多 ></span>
              </router-link>
            </div>
          </div>
          <div class="news_center">
            <p class="txtOver" v-for="(e,i) in newList" :key="i" @click="toDetails(e)"><span class="news_center_dian">·</span>{{e.title}}</p>
          </div>
        </div>
      </div>
      <div style="color: red; margin-bottom: 2rem;" v-if="orders > 0">
        您有 <span style="text-decoration: underline;">{{ orders }}</span> 笔费用待缴，请及时缴纳
        <span style="color: $primary; text-decoration: underline; cursor: pointer;" @click="toOrder">点击缴费</span>
      </div>
      <div class="newMine_content" v-if="schoolInfo.isOpenStudy">
        <div class="course_top">
          <div class="top_titile">近期课程</div>
          <div class="course_more">
            <router-link class="nav-link" :to="{ path: '/main/course' }">
              <span>查看全部 ></span>
            </router-link>
          </div>
        </div>
        <div class="newMine_coursePage_list d-flex d-flex-between d-flex-wrap">
          <div class="newMine_coursePage_li" v-for="(c, i) in courseList" :key="i">
            <div class="newMine_coursePage_li_l d-flex d-flex-middle d-flex-between">
              <img :src="c.logo||courseLogo" class="newMine_coursePage_li_img">
              <div class="newMine_coursePage_li_info d-flex-column d-flex-between ">
                <p class="newMine_coursePage_li_info_name txtOver">{{c.code}}-{{ c.name }}</p>
                <div class="newMine_coursePage_li_info_descLi d-flex d-flex-middle">
                  <img src="../assets/login/mine_play.png" class="newMine_coursePage_li_info_icon">
                  <p class="mr-md-2">【课件】</p>
                  <p>课时：{{ c.sumLessons }}节</p>
                </div>
                <!-- <p class="newMine_coursePage_li_info_descLi">最近观看时间： {{ c.time }}</p> -->
              </div>
            </div>
            <div class="newMine_coursePage_li_line d-flex d-flex-middle d-flex-between">
              <div class="d-flex-item">
                <div class="newMine_coursePage_li_lineBox">
                  <p :style="`width: ${c.ratio||0}%;`"></p>
                </div>
                <p class="newMine_coursePage_li_lineTxt">已学：{{ c.ratio||0 }}%</p>
              </div>
              <!-- <a href="javascript:void(0);" class="newMine_BoxLi_btn bgColor"  @click="toStudy(c)">开始学习</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <faceRecognition ref="faceRecognition" type="kj" @submit="toStudys" ></faceRecognition>
    <HomeChoose ref="homeChooseRef"></HomeChoose>
  </div>
</template>

<script>
import { mapState } from "vuex"
import faceRecognition from "@/components/faceRecognition.vue";
import HomeChoose from './HomeChoose.vue'

export default {
  components: {
    faceRecognition,
    HomeChoose
  },
  name: "Home",
  data () {
    return {
      loading: false,
      fit: 'fill',
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      newList: [],
      courseList: [],
      mapT:{},
      userPhoto: require(`@/assets/user.png`),
      courseLogo: require(`@/assets/login/kc.png`),
      orders: 0,
      isCanRefresh: JSON.parse(localStorage.getItem('login_choose')),
      homeExamConfigId: null,
    };
  },
  computed: {
    ...mapState(['user','tenantInfo', 'schoolInfo'])
  },
  created() {
    this.getData();
    this.getTypes('politicStatus')

    this.$http.get('/student/pc/myOrderNum').then((res) => {
      this.orders = res
    })
    this.$http.get('/student/pc/getSchoolExamConfig', {}).then((res) => {
      this.homeExamConfigId = res?.[0]?.id ?? null
    })
  },
  methods: {
    handleRefresh() {
      this.$refs.homeChooseRef.open(this.user.certiNo)
    },
    getData () {
      this.$http.post('/student/pc/index/info').then(res=>{
        this.newList=res.newList||[]
        this.courseList=res.courseList||[]
      })
    },
    getTypes(t){
      this.$http.post('/student/pc/common/getDictItemByTypes',['politi_type','eduLevel']).then((res) => {
        this.mapT=res
      })
    },
    mapType(t,m){
      return this.mapT[m]?.find(e=>e.value==t)?.label
    },
    toStudy(e) {
      this.tsItem=e
      if(e.openFaceRecognition){
        this.$refs.faceRecognition.open({ coursewareId: e.id, examConfigId: this.homeExamConfigId })
        return
      }
      this.toStudys(e)
    },
    toStudys(e=this.tsItem){
      this.$router.push({
        path: '/courseStudy',
        query:{
          id:e.id,
          examConfigId: this.homeExamConfigId,
        }
      })
    },
    toDetails(e) {
      this.$router.push({
        path: '/newsDetails',
        query:{
          id:e.id
        }
      })
    },
    toOrder(e) {
      this.$router.push({
        path: '/main/order',
      })
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";
.bgColor {
  background: #0065BA !important;
  color: #fff !important;
}

.txtOver {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.page-content {
  box-shadow: none;
  border: none;
  border-radius: 0;
  background: none;
}

.newMine_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;

  .newMine_info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
    width: 55%;
    height: 200px;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-right: 5px;

    .info_student {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      width: calc(100% - 150px);

      .info_student_icon {
        margin-right: 5px;
        height: 14px;
      }
    }
  }

  .newMine_news {
    padding: 20px;
    box-sizing: border-box;
    width: 44%;
    height: 200px;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-left: 5px;

    .news_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 40px;
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 10px;

      .news_more {
        span {
          color: $primary;
        }
      }
    }

    .news_center {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      p {
        line-height: 26px;
      }

      p:hover {
        font-weight: 650;
        cursor: pointer;
      }
    }

    .news_center_dian {
      font-size: 20px;
    }
  }
}

.newMine_content {
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  background: inherit;
  background-color: white;
  border-radius: 5px;

  .course_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 10px;

    .top_titile {
      color: #333;
      font-weight: 650;
      font-size: 16px;
    }
  }

  .course_more {
    span {
      color: #333333;
    }
  }

  .newMine_coursePage_list {
    box-sizing: border-box;
  }

  .newMine_coursePage_li {
    width: 49%;
    border-radius: 5px;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    padding: 12px 10px;
    margin-bottom: 30px;

    .newMine_coursePage_li_l {
      margin-bottom: 10px;
    }

    .newMine_coursePage_li_img {
      width: 150px;
      height: 85px;
      border-radius: 5px;
      border: 1px solid #F4F4F4;
    }

    .newMine_coursePage_li_info {
      width: calc(100% - 170px);
      height: 85px;
      margin-left: 10px;

      .newMine_coursePage_li_info_name {
        color: #333333;
      }

      .newMine_coursePage_li_info_icon {
        margin-right: 5px;
        height: 14px;
      }
    }

    .newMine_coursePage_li_lineTxt {
      font-size: 12px;
      color: #0065BA;
    }

    .newMine_coursePage_li_lineBox {
      height: 4px;
      background: #EDEDED;
      border-radius: 5px;
      position: relative;
      overflow: hidden;
      margin-bottom: 8px;

      p {
        height: 4px;
        background: #FFA800;
      }
    }

    .newMine_BoxLi_btn {
      width: 74px;
      height: 28px;
      line-height: 28px;
      border-radius: 14px;
      text-align: center;
      color: #999;
      margin-left: 15px;
      background: #eee;
    }
  }
}
</style>
